<template>
  <el-dialog :visible="true" @close="$emit('close')">
    <div class="text-center">
      <p>请用手机微信扫描下方二维码登记领奖</p>
      <p class="text-red text-medium" v-if="isTest">(测试答题，不真实发放红包)</p>
      <div>
        <img v-if="isTest" src="/img/wechat.jpg" />
        <vue-qr v-else :text="url"></vue-qr>
      </div>
      <p>15分钟有效，请尽快扫码</p>
      <p>（在微信搜索关注“调研工厂+”，随时查询领奖情况）</p>
      <p v-if="needAuditFlag" class="text-center text-large mt-5">
        红包由
        <span style="color: #ff4600">问卷发布者负责审核发放</span>
        ，请耐心等待
      </p>
      <p class="text-large">如有疑问，请联系问卷发布者</p>
    </div>
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'AwardPopup',
  components: { VueQr },
  props: {
    isTest: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    },
    needAuditFlag: {
      type: Boolean,
      default: false
    }
  }
}
</script>
